// Modules
import React, { useEffect, useState, useRef, useContext } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import PropTypes from "prop-types";

// Context
import ApiContext from "../../contexts/ApiContext";

// Local
import Divider from "../utils/Divider";
import FurnituresList from "./FurnituresList";

// Assets
import "./home-improvments.scss";
import ExpandIcon from "../../assets/img/svg/Expand_icon";
import Gauge from "../utils/Gauge";
import FlipImage from "../utils/FlipImage";

const HomeImprovments = (props) => {
  const { data, loader, rooms } = props;
  const {
    travaux_a_prevoir,
    mobilier_a_prevoir,
    plan_bien,
    est_termine,
    vieille_fiche,
  } = data;
  const { isMobile, isTablet } = useContext(ApiContext);

  // We initialize the variables to avoid having some undefined values displayed on screen.
  const travauxAPrevoir = travaux_a_prevoir
    ? String(travaux_a_prevoir)
    : "Calcul en cours...";
  const mobilierAPrevoir = mobilier_a_prevoir
    ? String(mobilier_a_prevoir)
    : "Calcul en cours...";

  const [panelExpanded, setPanelExpanded] = useState(null);
  const [heightPanel, setHeightPanel] = useState(null);

  const jauge_trav = useRef(50);
  const jauge_mobilier = useRef(50);

  /**
   * Sets the value of the angle of the needle on the gauges.
   */
  useEffect(() => {
    if (travauxAPrevoir !== undefined && mobilierAPrevoir !== undefined) {
      switch (travauxAPrevoir) {
        case "Aucuns travaux à prévoir":
          jauge_trav.current = 5;
          break;
        case "Léger rafraîchissement":
          jauge_trav.current = 50;
          break;
        case "À rénover":
          jauge_trav.current = 100;
          break;
        default:
          jauge_trav.current = 50;
      }

      switch (mobilierAPrevoir) {
        case "Déjà meublé":
          jauge_mobilier.current = 5;
          break;
        case "Compléter mobilier déjà présent":
          jauge_mobilier.current = 50;
          break;
        case "À meubler entièrement":
          jauge_mobilier.current = 100;
          break;
        default:
          jauge_mobilier.current = 50;
      }
    }
  }, [travauxAPrevoir, mobilierAPrevoir]);

  /**
   * Sets open / close the clicked panel
   * @param {String} panel : Name of the clicked panel
   */
  const toggleAccordionPanel = (panel) => {
    if (panel === panelExpanded) {
      setPanelExpanded(null);
      setHeightPanel(0);
    } else {
      setPanelExpanded(panel);
      setHeightPanel(document.getElementById(panel).scrollHeight);
    }
  };

  return (
    <React.Fragment>
      <Divider text="Aménagement" loader={loader} />
      <div className={`home-improvments-container ${isMobile === true || isTablet === true ? "mobile" : ""}`}>
        <div className="left-wrapper">
          <div className="gauges-wrapper">
            <Gauge
              clssName="gauge-chart-one"
              percent={jauge_trav.current}
              text={travauxAPrevoir}
              loader={loader}
            />

            <Gauge
              clssName="gauge-chart-two"
              percent={jauge_mobilier.current}
              text={mobilierAPrevoir}
              loader={loader}
            />
          </div>

          <div className="accordions-wrapper">
            {rooms.map((room, index) => (
              <div className="accordion" key={room.label}>
                {loader ? (
                  <React.Fragment>
                    <button
                      className={`header ${panelExpanded === `panel-${room.label}` ? "active" : ""
                        }`}
                      onClick={() => toggleAccordionPanel(`panel-${room.label}`)}
                    >
                      <Skeleton animation="wave" variant="text" width="20vw" />
                      <ExpandIcon clssName="expand-icon" />
                    </button>
                    <div
                      className={`panel ${panelExpanded === `panel-${room.label}` ? "active" : ""
                        }`}
                      id={`panel-${room.label}`}
                      style={
                        panelExpanded === `panel-${room.label}`
                          ? { maxHeight: `${heightPanel}px` }
                          : {}
                      }
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "80%",
                          margin: "0 auto",
                          marginTop: "1vh",
                          height: "max-content",
                        }}
                      >
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width="25vw"
                          height="15vh"
                        />
                      </div>
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <button
                      className={`header ${panelExpanded === `panel-${room.label}` ? "active" : ""
                        }`}
                      onClick={() => toggleAccordionPanel(`panel-${room.label}`)}
                    >
                      {room.label}
                      <ExpandIcon clssName="expand-icon" />
                    </button>
                    <div
                      className={`panel ${panelExpanded === `panel-${room.label}` ? "active" : ""
                        }`}
                      id={`panel-${room.label}`}
                      style={
                        panelExpanded === `panel-${room.label}`
                          ? { maxHeight: `${heightPanel}px` }
                          : {}
                      }
                    >
                      {room.img && room.imgBack && (vieille_fiche === false || vieille_fiche === null)
                        ? (
                          <div className="image-wrapper">
                            <FlipImage
                              clssName="flip-image-home-improvments"
                              srcFront={room.img}
                              srcBack={room.imgBack}
                              roomName={room.label}
                              est_termine={est_termine}
                            />
                          </div>
                        ) : null}
                      {room.imgBack && vieille_fiche === true
                        ? (
                          <div className="image-wrapper">
                            <div
                              className="image-no-flip"
                              style={{ backgroundImage: `url(${room.imgBack})` }}
                              title={room.label}
                            />
                          </div>
                        ) : null}
                      {room.descr && (est_termine === false || est_termine === undefined) ?
                        <p className="p-wrapper-descr">{room.descr}</p>
                        : est_termine === false
                          ? <p className="p-wrapper-descr">Aucun travaux à prévoir.</p>
                          : null}
                      {room.label.includes("Lots") === false
                        ? (
                          <div className="furnitures-container">
                            <h6>
                              {est_termine === false || est_termine === undefined
                                ? "Aménagement prévu"
                                : "Aménagement"}
                            </h6>
                            <ul className="furnitures-list">
                              <FurnituresList currentRoom={room.label} />
                            </ul>
                          </div>
                        ) : null}
                    </div>
                  </React.Fragment>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="right-wrapper">
          {loader ? (
            <div className="skeleton-div">
              <Skeleton variant="rect" width="70vh" height="70vh" />
            </div>
          ) : (
            <img
              className="threeD-plan"
              src={plan_bien}
              alt="Plan 3D"
            />
          )}
        </div>
      </div>
    </React.Fragment >
  );
};

HomeImprovments.propTypes = {
  loader: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  rooms: PropTypes.array.isRequired,
};

export default HomeImprovments;
